import { FormControl, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES, SupportedLanguage } from '../../i18n';

function resolveSupportedLanguage(lng: string | undefined): SupportedLanguage {
  const normalized = (lng ?? 'en').toLowerCase();

  return (
    SUPPORTED_LANGUAGES.find(
      (supported) =>
        normalized === supported || normalized.startsWith(`${supported}-`),
    ) ?? 'en'
  );
}

export function LanguageSwitcherComponent() {
  const { i18n, t } = useTranslation();
  const language = useMemo(
    () => resolveSupportedLanguage(i18n.resolvedLanguage ?? i18n.language),
    [i18n.language, i18n.resolvedLanguage],
  );

  const handleChange = (event: SelectChangeEvent<SupportedLanguage>) => {
    void i18n.changeLanguage(event.target.value);
  };

  return (
    <FormControl size="small" sx={{ minWidth: 40 }}>
      <Select
        value={language}
        onChange={handleChange}
        aria-label={t('language.label')}
        renderValue={(value) => value.toUpperCase()}
        MenuProps={{
          slotProps: {
            paper: {
              sx: { fontSize: 12 },
            },
          },
        }}
        sx={{
          height: 28,
          fontSize: 11,
          '& .MuiSelect-select': {
            py: 0,
            px: 0.75,
            pr: '18px !important',
            display: 'flex',
            alignItems: 'center',
          },
          '& .MuiSelect-icon': {
            right: 0,
            fontSize: 16,
          },
        }}
      >
        {SUPPORTED_LANGUAGES.map((lng) => (
          <MenuItem key={lng} value={lng} dense sx={{ fontSize: 12, minHeight: 28 }}>
            {t(`language.${lng}`)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
